module.exports = __webpack_public_path__ + "img/shipo-icon-water.524c957d.svg";